import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  BillsFilterValue,
  BillsValue,
  BillsFiltersCount,
} from 'ha/types/SearchFilters';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

export interface Props {
  value: BillsFilterValue;
  onChange: (value: BillsFilterValue) => void;
  count?: BillsFiltersCount;
}

const BillsFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onChange}
      options={[
        {
          value: BillsValue.INCLUDED,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Bills Included')}
              count={count?.included}
            />
          ),
          testLocator: 'Filter Bills Included',
        },
      ]}
    />
  );
};

export default BillsFilter;
